module.exports = __webpack_public_path__ + "849c33cd5d9802478e4854d9bc3cd43c.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/media/fonts/GT-Walsheim-Pro-Ultra-Bold-Oblique.ttf
// module id = 1246
// module chunks = 0